import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Container, Row, Col, Navbar } from "react-bootstrap";
import Footer from "../../../footer/footer";

export default function PrivacyPolicy() {
  return (
    <div style={{ fontFamily: "Montserrat, serif" }}>
      {/* Header */}
      <Navbar bg="white" expand="lg" className="py-3">
        <Container>
          <Navbar.Brand as={Link} to="/home">
            <img src="/assets/img/new-logo.svg" alt="Spacia" width={150} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                marginLeft: "50px",
                marginRight: "50px",
              }}
            >
              <nav
                style={{
                  fontSize: "16px",
                  display: "flex",
                  gap: "30px",
                  color: "black",
                }}
              >
                <NavLink to="/host" style={{ color: "black" }} activeClassName="active-link">
                  Become A Host
                </NavLink>
                <NavLink to="/corporate-page" style={{ color: "black" }} activeClassName="active-link">
                  Enterprise Solutions
                </NavLink>
                <NavLink to="/signin" style={{ color: "black" }} activeClassName="active-link">
                  Find A Space
                </NavLink>
                <a href="/corporate-page#faqSection" style={{ color: "black" }}>
                  FAQ
                </a>
              </nav>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Main Content */}
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <div className="mb-5">
              <h1 className="display-4 mb-3">Privacy Statement</h1>
              <p className="text-muted">Version Number: 1.0 | Effective Date: 17th February, 2026</p>
            </div>

            <div className="bg-white p-4 rounded shadow-sm">
              <section className="mb-5">
                <h2 className="h3 mb-4">Introduction</h2>
                <p className="text-secondary">
                  theSOFTtribe Limited ("theSOFTtribe", "we", "us", or "our") is a Ghanaian software development company
                  established in 1991, specializing in enterprise and institutional software systems. We are committed
                  to protecting personal data in accordance with the Data Protection Act, 2012 (Act 843) of Ghana and,
                  where applicable, international data protection standards including the GDPR. theSOFTtribe Limited is
                  registered with the Data Protection Commission (DPC) of Ghana. This Privacy Statement explains how we
                  collect, use, process, store, transfer, and protect personal data.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Our Role in Data Protection</h2>
                <p className="text-secondary">
                  We may act either as a Data Controller or Data Processor depending on the service provided.
                </p>
                <ul className="text-secondary">
                  <li className="mb-2">
                    <strong>As Data Controller:</strong> For website visitors, job applicants, direct contacts, and
                    events managed directly by theSOFTtribe.
                  </li>
                  <li className="mb-2">
                    <strong>As Data Processor:</strong> For enterprise platforms (e.g., Payroll, ERP, Institutional
                    Systems), where the Client Organization determines the purpose of processing and we act strictly
                    under their documented instructions.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Categories of Personal Data We Process</h2>
                <ul className="text-secondary">
                  <li className="mb-2">
                    Identity and Contact Information (name, email, phone, DOB, national ID, photos)
                  </li>
                  <li className="mb-2">
                    Professional/Institutional Information (employee/student ID, SSNIT, department)
                  </li>
                  <li className="mb-2">Financial Information (bank details, salary, tax identifiers)</li>
                  <li className="mb-2">Technical and Usage Data (IP address, device info, system logs)</li>
                  <li className="mb-2">Cookies and authentication session data</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Lawful Basis for Processing</h2>
                <p className="text-secondary">We process personal data under the following lawful bases:</p>
                <ul className="text-secondary">
                  <li className="mb-2">Contractual Necessity</li>
                  <li className="mb-2">Legal Obligation</li>
                  <li className="mb-2">Legitimate Interest (security, fraud prevention, system optimization)</li>
                  <li className="mb-2">Consent (where explicitly required)</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">How We Use Personal Data</h2>
                <p className="text-secondary">We use personal data to:</p>
                <ul className="text-secondary">
                  <li className="mb-2">Provide and administer access to our platforms</li>
                  <li className="mb-2">Authenticate users</li>
                  <li className="mb-2">Process payroll and statutory deductions</li>
                  <li className="mb-2">Deliver enterprise and institutional services</li>
                  <li className="mb-2">Provide support and troubleshooting</li>
                  <li className="mb-2">Improve system performance and security</li>
                  <li className="mb-2">Meet legal and regulatory obligations</li>
                </ul>
                <p className="text-secondary mt-3">
                  We may use de-identified, aggregated data for analytics and system improvement. We do not use
                  identifiable personal data for automated decision-making or AI training without lawful basis or
                  explicit consent.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Sub-Processors and Data Sharing</h2>
                <p className="text-secondary">We do not sell personal data. We may share data with:</p>
                <ul className="text-secondary">
                  <li className="mb-2">Client Organizations (Data Controllers)</li>
                  <li className="mb-2">Tier 1 Cloud Providers (e.g., AWS or Microsoft Azure)</li>
                  <li className="mb-2">Regulatory authorities where legally required</li>
                  <li className="mb-2">Authorized third-party integrations under contractual safeguards</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">International Data Transfers</h2>
                <p className="text-secondary">
                  Where data is transferred outside Ghana, appropriate safeguards are implemented including contractual
                  data processing agreements and equivalent legal protection mechanisms ensuring protection equal to or
                  higher than Act 843.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Data Retention</h2>
                <p className="text-secondary">
                  We retain personal data only as long as necessary to fulfill its purpose or comply with legal
                  obligations. Payroll and tax data are retained in accordance with statutory requirements. System logs
                  and support records are retained for operational, security, and audit purposes. Data is securely
                  deleted or anonymised when no longer required.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Security Measures</h2>
                <p className="text-secondary">
                  We implement appropriate technical and organisational safeguards including:
                </p>
                <ul className="text-secondary">
                  <li className="mb-2">Encryption of data at rest and in transit</li>
                  <li className="mb-2">Role-based access controls (least privilege)</li>
                  <li className="mb-2">Multi-factor authentication where applicable</li>
                  <li className="mb-2">Continuous monitoring and logging</li>
                  <li className="mb-2">Vulnerability assessments</li>
                  <li className="mb-2">Incident response protocols</li>
                  <li className="mb-2">Staff data protection training</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Data Breach Notification</h2>
                <p className="text-secondary">In the event of a personal data breach posing risk to data subjects:</p>
                <ul className="text-secondary">
                  <li className="mb-2">We will notify the relevant Data Controller without undue delay.</li>
                  <li className="mb-2">We will notify the Data Protection Commission where required.</li>
                  <li className="mb-2">Affected individuals will be informed in accordance with legal requirements.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Processing of Minors' Data</h2>
                <p className="text-secondary">
                  Where systems are used by educational institutions, the institution acts as the Data Controller. We
                  process minors' data strictly under their lawful authority and documented instructions.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Your Rights Under Act 843</h2>
                <p className="text-secondary">You have the right to:</p>
                <ul className="text-secondary">
                  <li className="mb-2">Access your personal data</li>
                  <li className="mb-2">Request correction of inaccurate data</li>
                  <li className="mb-2">Request erasure where appropriate</li>
                  <li className="mb-2">Object to processing based on legitimate interest</li>
                  <li className="mb-2">Request data portability</li>
                  <li className="mb-2">Withdraw consent where processing is based on consent</li>
                </ul>
                <p className="text-secondary mt-3">
                  Where we act as Data Processor, such requests should be directed to the relevant Client Organization.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Complaints</h2>
                <p className="text-secondary">
                  If you believe your data protection rights have been violated, you may contact us directly and/or
                  lodge a complaint with the Data Protection Commission (DPC) of Ghana.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Contact Information</h2>
                <p className="text-secondary">For inquiries or to exercise your rights:</p>
                <ul className="text-secondary">
                  <li className="mb-2">
                    <strong>David Bolton</strong>
                    <br />
                    Email: <a href="mailto:david.boltonjnr@softtribe.com">david.boltonjnr@softtribe.com</a>
                  </li>
                  <li className="mb-2">
                    <strong>Dabaindeh Findley-Antonio</strong>
                    <br />
                    Email:{" "}
                    <a href="mailto:dabaindeh.findley-antonio@softtribe.com">dabaindeh.findley-antonio@softtribe.com</a>
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h3 mb-4">Updates</h2>
                <p className="text-secondary">
                  We may update this Privacy Statement from time to time to reflect changes in legal requirements,
                  technology, or our services. The latest version will always be available on our platforms and website.
                </p>
              </section>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Footer */}
      <Footer />
    </div>
  );
}
